module.exports = __webpack_public_path__ + "img/about1 (1).67f612d5.png";